import { z } from 'zod';
import { BaseEntitySchema, HexColorSchema } from './common';
import { ImageId, PlayerId, UserId } from './ids';

/**
 * Reusable schema for player handle validation
 * Format: starts with letter, alphanumeric + hyphen (no underscore)
 * Length: 3-30 characters
 */
export const PlayerHandleSchema = z
  .string()
  .min(3)
  .max(30)
  .regex(/^[a-zA-Z][a-zA-Z0-9-]*$/, {
    message: 'Handle must start with a letter and contain only letters, numbers, and hyphens',
  });

export const PlayerSchema = BaseEntitySchema.extend({
  id: PlayerId,
  name: z
    .string()
    .max(100)
    .refine((value) => value.trim().length > 0, {
      message: 'Name must have at least 1 non-space character',
    }),
  nickname: z
    .string()
    .max(50)
    .optional()
    .refine((value) => !value || (value.trim().length > 0 && /\p{L}/u.test(value)), {
      message: 'Nickname must contain at least one letter',
    }),
  handle: PlayerHandleSchema.optional(),
  avatarImageId: ImageId.optional(),
  color: HexColorSchema.optional(),
  createdBy: UserId.optional(), // User who created the player (from PlayerCreated event, immutable)
  userId: UserId.optional(), // User who claimed the player (from PlayerClaimed event, can be cleared)
});
export type Player = z.infer<typeof PlayerSchema>;
